import { render, staticRenderFns } from "./ZeroxaItem.vue?vue&type=template&id=eb79cffc&"
import script from "./ZeroxaItem.vue?vue&type=script&lang=js&"
export * from "./ZeroxaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports